import React from "react";
import useAIConfigs from "@/hooks/useAIConfigs";
import NewAILanding from "./NewAILanding";
import { LoadingSpinner, TableBase } from "@velaro/velaro-component-lib";
import ActionBar from "../../ChatWindow/ActionBar";
import { useNavigate } from "react-router-dom";

export default function AI() {
  const { aiConfigurations, loading, remove } = useAIConfigs();
  const navigate = useNavigate();

  if (loading) return <LoadingSpinner />;

  if (aiConfigurations.length === 0) return <NewAILanding />;

  const handleDelete = (id: number) => {
    const index = aiConfigurations.findIndex((c) => c.id === id);

    if (index === -1) return;

    remove(aiConfigurations[index], index);
  };

  const handleEdit = (id: number) => {
    navigate(`/ai/settings/general/${id}`);
  };

  const columns = [
    { label: "Name", accessor: "name" },
    { label: "AI Model", accessor: "aiModel" },
    { label: "Metrics", accessor: "metrics" },
    { label: "Updated", accessor: "updated" },
    { label: "Status", accessor: "status" },
    { label: "Actions", accessor: "actions" }
  ];

  const tableData = aiConfigurations.map((aiConfig) => ({
    ...aiConfig,
    name: aiConfig.name,
    aiModel: aiConfig.aiModel,
    metrics: "--",
    updated: "--",
    status: aiConfig.status,
    actions: (
      <>
        <ActionBar
          onEdit={() => {
            handleEdit(aiConfig.id);
          }}
          onCopy={() => {}}
          onDelete={() => {
            handleDelete(aiConfig.id);
          }}
        />
      </>
    )
  }));

  return (
    <>
      <div className="overflow-auto h-full">
        <TableBase columns={columns} data={tableData} />
      </div>
    </>
  );
}
